import React from 'react';
import { Card, Col, Collapse, Row, Switch, FormInstance, Form } from 'antd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { CaretRightOutlined } from '@ant-design/icons';
import FormulaList from 'components/FormulaList';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import Title from 'components/Title';
import RoleList from './RoleList';
import UtinaCard from 'components/UtinaCard';
import { isNil } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';
const { Panel } = Collapse;
export type RoleProps = {
  form: FormInstance;
  id: number;
  tpadrid?: number;
  showAsModal?: boolean;
  refetch?: boolean;
  refetchTp?: () => void;
  data?: any;
};
const RolesCard = (props: RoleProps) => {
  const { refetch, refetchTp, form, data } = props;

  return (
    <>
      <Card
        title={<GetLabel label="defaultAttributes" style={{fontWeight:'bold',paddingLeft:15}}/>}
        style={{
          width: '100%',
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          marginBottom: 10,
          
        }}
        bordered
      >
        <Card>
          <Row gutter={16}>
            <Col xs={12} lg={12}>
              <UtinaCard
                comcode="Payment"
                level={5}
                style={{ marginTop: 18, }}
                additionalAttribute
              >
                <FormInput col xs={12} name="tppaymodein">
                  <ParListSelect
                    parcode="PAYMODEIN"
                    disabled={!!props.id && !isNil(data?.role?.tppaymodein)}
                  />
                </FormInput>
                <FormInput col xs={12} name="tppaydelayin">
                  <ParListSelect
                    parcode="PAYDELAYIN"
                    disabled={!!props.id && !isNil(data?.role?.tppaydelayin)}
                  />
                </FormInput>

                <FormInput col xs={12} name="tppaymodeout">
                  <ParListSelect
                    parcode="PAYMODEOUT"
                    disabled={!!props.id && !isNil(data?.role?.tppaymodeout)}
                  />
                </FormInput>
                <FormInput col xs={12} name="tppaydelayout">
                  <ParListSelect
                    parcode="PAYDELAYOU"
                    disabled={!!props.id && !isNil(data?.role?.tppaydelayout)}
                  />
                </FormInput>
              </UtinaCard>
            </Col>

            <UtinaCard comcode="Others" level={5} lg={11} additionalAttribute>
              <Form.Item shouldUpdate={() => true} noStyle>
                {({ getFieldValue }) => {
                  return (
                    <FormInput col xs={16} name="tplateinterestformula">
                      <FormulaList
                        params={{
                          ctecategory: '',
                          ctetype: 'LATEIN',
                          duration: 0,
                          finamount: 0,
                          priid: 0,
                          prilabel: '',
                          pristatus: '',
                        }}
                        disabled={
                          !!props.id && !isNil(data?.role?.tplateinterestformula)
                        }
                      />
                    </FormInput>
                  );
                }}
              </Form.Item>
              <FormInput
                col
                xs={8}
                name="tpblocklateinterestinvoicing"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  disabled={
                    !!props.id && !isNil(data?.role?.tpblocklateinterestinvoicing)
                  }
                />
              </FormInput>
              <Form.Item shouldUpdate={() => true} noStyle>
                {({ getFieldValue }) => {
                  return (
                    <FormInput col xs={16} name="tprejectionfeesformula">
                      <FormulaList
                        params={{
                          ctecategory: '',
                          ctetype: 'REJFEES',
                          duration: 0,
                          finamount: 0,
                          priid: 0,
                          prilabel: '',
                          pristatus: '',
                        }}
                        disabled={
                          !!props.id && !isNil(data?.role?.tprejectionfeesformula)
                        }
                      />
                    </FormInput>
                  );
                }}
              </Form.Item>
              <FormInput
                col
                xs={8}
                name="tpblockrejectionfeesinvoicing"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  disabled={
                    !!props.id && !isNil(data?.role?.tpblockrejectionfeesinvoicing)
                  }
                />
              </FormInput>
              <FormInput col xs={16} name="tpreminderfeesformula">
                <FormulaList
                  params={{
                    ctecategory: '',
                    ctetype: 'REMINF',
                    duration: 0,
                    finamount: 0,
                    priid: 0,
                    prilabel: '',
                    pristatus: '',
                  }}
                  disabled={!!props.id && !isNil(data?.role?.tpreminderfeesformula)}
                />
              </FormInput>
              <FormInput
                col
                xs={8}
                name="tpblockreminderfeesinvoicing"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  disabled={
                    !!props.id && !isNil(data?.role?.tpblockreminderfeesinvoicing)
                  }
                  style={{ opacity: '0.7' }}
                />
              </FormInput>
            </UtinaCard>

            {/* style={{color:!!props.id&&"red" }} */}
            {/* <FormInput col xs={12} name="tpmainadrstreet1" >
              <AddresseListSelect params={{ tpid:props.form.getFieldValue('tpid')}} disabled={!props.id}/>
            </FormInput>
            <FormInput col xs={12} name="tpbankname">
              <BankAccountListSelect params={{ tpid:props.form.getFieldValue('tpid')}} disabled={!props.id}/>
            </FormInput> */}
          </Row>
        </Card>
      </Card>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined
            style={{ fontSize: 24, float: 'left' }}
            rotate={isActive ? 90 : 0}
          />
        )}
        expandIconPosition="left"
      >
        <Panel
          disabled={
            !props.id
          }
          header={<Title level={5} comcode="all-roles"></Title>}
          key="2"
          style={{
            marginBottom: 24,
            overflow: 'hidden',
            background: '#f7f7f7',
            border: 10,
            borderRadius: 2,
            boxShadow:
              'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          }}
        >
          <Card>
            <RoleList
              form={props.form}
              tpid={props.id}
              showAsModal={props.showAsModal}
              refetech={refetch}
              refetchTp={refetchTp}
            />
          </Card>
        </Panel>
      </Collapse>
    </>
  );
};

export default RolesCard;
